<div class="input-group">
    <input placeholder="dd/mm/yyyy" class="form-control" [(ngModel)]="date" ngbDatepicker [disabled]="disabled" #edDatepicker="ngbDatepicker" (ngModelChange)="onDateChanged($event)" />
    <button class="btn btn-outline-secondary bi bi-calendar3" (click)="edDatepicker.toggle()" type="button"></button>
</div>